import { classNames } from 'primereact/utils';
import React, { CSSProperties, forwardRef, ReactNode, Ref } from 'react';

interface Props {
	id?: string;
	title: ReactNode;
	additional?: string;
	right?: ReactNode | (() => ReactNode);
	additionalStyles?: CSSProperties;
	className?: string;
}

const SubPageTitle = forwardRef(
	({ id, title, additional, right, additionalStyles, className }: Props, ref: Ref<HTMLDivElement>) => (
		<div
			ref={ref}
			id={id}
			className={classNames(
				'sub-page-title flex flex-row flex-wrap align-items-center justify-content-between mb-1 ml-2 font-bold text-black',
				className
			)}
			style={{
				...additionalStyles,
			}}
		>
			<div className="py-3">
				<span className="sub-page-title__text font-bold text-base">{title}</span>
				{additional && additional.length && (
					<span
						className="text-sm text-500 font-light ml-3 text-bold text-sm"
						style={{
							...additionalStyles,
						}}
					>
						{additional}
					</span>
				)}
			</div>
			{right && typeof right === 'function' ? right() : right}
		</div>
	)
);

export default SubPageTitle;
